import { httpPost } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSelectInstallmentPlan = async ({
  intentId,
  planId,
  issuerCode,
  lang,
}: {
  intentId: string;
  planId: string;
  issuerCode?: string;
  lang: string;
}) => {
  const response = await httpPost<PaymentApiResponse>(
    `payments/intents/${intentId}/installment_plans/?lang=${lang}`,
    {
      installment_id: planId,
      ...(issuerCode && { issuer_code: issuerCode }),
    }
  );
  return formatPaymentResponse(response);
};
